import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Scheduling|Eligible Exams Menu|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateSchedulingEligibleExamsMenu';
export type SPCandidateSchedulingEligibleExamsMenuLocNames = `${LocNameStart}ContentSchedule`;

export const spCandidateSchedulingEligibleExamsMenuLocs: LocDefs<SPCandidateSchedulingEligibleExamsMenuLocNames> =
	{
		SPCandidateSchedulingEligibleExamsMenuContentSchedule: {
			defaultValue: 'Schedule',
			description: 'Schedule button',
			displayPath: `${pathStart}Schedule`,
			displayType: 'Content',
			...sharedProperties,
		},
	};

export type SPCandidateSchedulingEligibleExamsMenuLocType =
	LocMap<SPCandidateSchedulingEligibleExamsMenuLocNames>;
